import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from "vue";
import ApprovalTableBase, { HeaderType } from "./ApprovalTableBase.vue";
import { ApprovalVacationResponse } from "@/models/approval/ApprovalResponse";
import { ApprovalSearchRequest } from "@/models/approval/ApprovalRequest";
import { Authority } from "@/models/enum/Enum";
import { Paths } from "@/plugins/api/paths";
import { $post } from "@/plugins/api/api";
import { $confirm } from "@/plugins/confirm/confirm";
import { $alert } from "@/plugins/alert/alert";
import { useApproval } from "@/composable/Approval";
import VacationDialog from "../form/VacationDialog.vue";
import VacationExpandItem from "../expand/VacationExpandItem.vue";
import Vuex from "@/store/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'VacationTable',
  setup(__props) {

const approval = useApproval();

const header: HeaderType = {
  key: "recordId",
  date: "vacatioinDays",
  user: "employeeName",
  affiliation: "affiliationName",
  approval: "approvalState"
};

const title = "休暇申請承認";

const selected = ref<ApprovalVacationResponse[]>([]);
const items = ref<ApprovalVacationResponse[]>([]);
const form = ref<ApprovalSearchRequest>(approval.getForm());

const isDisabled = computed(() => {
  const authority = Vuex.state.authority;
  return authority < Authority.Manager;
});

const getItems = async (request: ApprovalSearchRequest) => {
  const response = await $post<ApprovalVacationResponse[]>(
    Paths.approval.vacation.search,
    request
  );
  if (response) items.value = response;
};

const onSearch = async () => {
  await getItems(form.value);
};

const onResolve = async (
  items: ApprovalVacationResponse[],
  selected: ApprovalVacationResponse[]
) => {
  const message = `${items.length}件承認します。\nよろしいですか？`;
  if (!(await $confirm(message))) return;

  const result = await $post(Paths.approval.vacation.resolve, items);
  if (result) $alert("success", `${result}件承認しました。`);
  await onSearch();

  console.log("selected", selected);
  selected = [];
};

const onReject = async (
  items: ApprovalVacationResponse[],
  selected: ApprovalVacationResponse[]
) => {
  const message = `${items.length}件却下します。\nよろしいですか？`;
  if (!(await $confirm(message))) return;

  const result = await $post(Paths.approval.vacation.reject, items);
  if (result) $alert("success", `${result}件却下しました。`);
  await onSearch();

  console.log("selected", selected);
  selected = [];
};

const onCancel = async (
  item: ApprovalVacationResponse,
  selected: ApprovalVacationResponse[]
) => {
  const message = "承認を取り消します。\nよろしいですか？";
  if (!(await $confirm(message))) return;

  const result = await $post(
    `${Paths.approval.vacation.cancel}/${item.recordId}`
  );
  if (result) {
    $alert("success", "取消に成功しました。");
    await onSearch();

    console.log("selected", selected);
    selected = [];
  }
};

onMounted(async () => {
  await onSearch();
});

return { __sfc: true,approval, header, title, selected, items, form, isDisabled, getItems, onSearch, onResolve, onReject, onCancel, ApprovalTableBase, VacationDialog, VacationExpandItem }
}

})